<template>
  <v-container class="pa-1" fluid grid-list-xs>
    <v-layout row wrap>
      <v-flex v-for="(starter, index) in starters" :key="starter.id" xs12>
        <v-card height="100%">
          <v-card-title primary-title="primary-title">
            <v-layout row wrap>
              <v-flex xs12>
                <div class="headline left" v-text="starter.name"></div>
                <div class="headline right">
                  <v-btn flat icon :disabled="loading" @click="$emit('changeFinalState')">
                    <v-icon>edit</v-icon>
                  </v-btn>
                  <strong>{{ $n(priceSum(starter), 'currency') }}</strong></div>
              </v-flex>
              <v-flex xs12 v-if="starter.starter_registrations">
                <item-list :items="starter.starter_registrations" :data-table-config="dataTableConfig" :filter="false"
                           :loading="loading" elevation="0" show-actions></item-list>
              </v-flex>
            </v-layout>
          </v-card-title>
        </v-card>
      </v-flex>
      <v-flex xs12 md9>
        <accept-conditions :value.sync="conditions" :disabled="loading" contest-rules
                           required="required"></accept-conditions>
      </v-flex>
      <v-flex xs12 md3>
        <h1 v-if="useBalance" class="right">Guthaben: {{ $n(user.balance / 100., 'currency') }}</h1>
        <h1 class="right">Summe: {{ $n(totalSum(), 'currency') }}</h1>
      </v-flex>
      <v-flex xs12>
        <v-btn class="right mx-0 pl-2 pr-2" :disabled="!conditions || loading" :loading="loading" color="primary"
               @click="submit">{{ $t(event.generate_invoices ? 'buy_registrations' : 'submit_registrations') }}
        </v-btn>
        <v-btn class="right mx-0" :disabled="loading" flat @click.native="$emit('back')" v-t="'back'"></v-btn>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import AcceptConditions from '../../common/AcceptConditions';
import ItemList from '../../../components/common/ItemList';
import {mapState} from "vuex";

export default {
  components: {
    AcceptConditions,
    ItemList
  },
  props: {
    event: {
      type: Object,
      default: null
    },
    paymentMethod: {
      type: String,
      required: true
    },
    starters: {
      type: Array,
      default: () => []
    },
    useBalance: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      conditions: false,
      loading: false,
      registrations: [],
      dataTableConfig: {
        loadingDataText: 'Keine Meldungen vorhanden',
        noDataText: 'Keine Meldungen vorhanden',
        rowsPerPageText: 'Zeilen pro Seite',
        headers: [
          {text: 'Typ', value: 'starter_type.name', align: 'left', translate: true},
          {text: 'Altersklasse', value: 'age_group.name', align: 'left'},
          {text: 'Style', value: 'starter_style.name', align: 'left'},
          {text: 'Preis', value: 'price_string', align: 'left'}
        ],
        items: {
          large: [
            {value: 'starter_type.name', translate: true},
            {value: 'age_group.name'},
            {value: 'starter_style.name'},
            {value: 'price_string'}
          ],
          small: [
            {value: 'starter_type.name', translate: true},
            {value: 'age_group.name'},
            {value: 'starter_style.name'},
            {value: 'price_string'}
          ]
        }
      },
      actions: [
        {
          label: this.$t('edit'),
          icon: 'edit',
          loading: registration => false,
          disabled: registration => false,
          click: registration => {
          }
        }
      ],
      cancelRequest: null
    }
  },
  computed: {
    ...mapState(['user'])
  },
  methods: {
    submit() {
      if (this.loading) {
        return;
      }

      this.loading = true;

      this.$store.commit('confirm', {
        headline: 'Meldevorgang abschließen?',
        text: this.$t('questions.submit_registration_' + (this.event.generate_invoices ? 'with_invoices' : 'without_invoices')),
        cancel: () => {
          this.loading = false;
        },
        callback: () => {
          axios.post('/api/v1/starters/register', {
            event_id: this.event.id,
            payment_method: this.paymentMethod,
            use_balance: this.useBalance
          }).then(response => {
            if (!response.data.success) {
              return;
            }

            _.each(response.data.data.event_registrations, registration => {
              this.$store.commit('addRegistration', registration);
            });

            if (response.data.data.hasOwnProperty('payment_url')) {
              window.location = response.data.data.payment_url;
              return;
            }

            this.$store.dispatch('loadRegistrations');
            this.$store.dispatch('loadStarters');
            this.$store.dispatch('loadUser');
            this.loading = false;
            this.$emit('submit');
          });
        }
      });
    },
    priceSum(starter) {
      return _.sumBy(starter.starter_registrations, 'price') / 100;
    },
    totalSum() {
      let balance = 0;
      if (this.useBalance) {
        balance = this.user.balance;
      }
      return (_.sumBy(this.starters, s => _.sumBy(s.starter_registrations, 'price')) - balance) / 100.;
    }
  }
}
</script>
